import styled from 'styled-components'

const borderColor = (props) => props.theme.global.colors['light-7']
const darkColor = (props) => props.theme.global.colors['dark-2']
const bgColor = (props) => props.theme.global.colors['background-back']

export const Container = styled.div`
  border-bottom: 1px solid ${borderColor};
  margin-bottom: 32px;

  @media only screen and (max-width: 768px) {
    margin-bottom: 24px;
  }

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
  }
`

export const OrderInfo = styled.div`
  padding: 24px;
  border: 1px solid ${borderColor};
  border-radius: 4px;

  @media only screen and (max-width: 768px) {
    padding: 16px;
  }
`

export const OrderInfoFlexBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;
`

export const Quantity = styled.p`
  background-color: ${bgColor};
  width: 100%;
  height: 31px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 165%;
  margin: 8px 0 0;
`

export const TextWrapper = styled.p`
  margin: 0 0 16px;

  span {
    font-size: 16px;
    line-height: 165%;
    font-weight: 400;
    color: ${darkColor};

    @media only screen and (max-width: 768px) {
      font-size: 14px;
    }
  }

  span:first-child {
    text-transform: uppercase;
    font-weight: 600;
  }
`

export const TextWrapper2 = styled.div`
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;

  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 165%;
    color: ${darkColor};
  }
`

export const ItemTotal = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  color: ${darkColor};
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`

export const ReturnRequest = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 165%;
  color: ${darkColor};
  margin: 24px 0;

  @media only screen and (max-width: 768px) {
    margin: 16px 0;
  }
`

export const ReturnDetailsContainer = styled.div`
  margin: 0 0 32px;
`
